onLoad(($) => {
  const nodes = $('.JS-cetip-voice');

  if (!nodes.length) return;

  const settlementRadio = $('.JS-settlement-radio');
  const assetsWithCetipVoice = ['cra', 'cri', 'cdca', 'deb'];

  const refreshRadio = function(node) {
    const settlementType = $('input[name="ticket_private_fixed_income[settlement_type]"]:checked').val() || 
                           $('input[name="ticket_dation_payment[settlement_type]"]:checked').val();
    
    // Para título privado
    const field = $('#ticket_private_fixed_income_is_cetip_voice');
    const assetTypeValue = $('#ticket_private_fixed_income_asset_type').children('option:selected').val();

    if (settlementType == 'cetip' && field.length > 0 && assetsWithCetipVoice.includes(assetTypeValue)) {
      $('#ticket_private_fixed_income_is_cetip_voice').removeAttr('readonly').removeAttr('disabled').show().parent().show();
    } else if (field.length > 0) {
      $('#ticket_private_fixed_income_is_cetip_voice').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
    }

    // Para dação - depósito
    const fieldDeposit = $('#ticket_dation_payment_is_cetip_voice_deposit');
    const assetTypeValueDeposit = $('#ticket_dation_payment_asset_type_deposit').children('option:selected').val();

    if (settlementType == 'cetip' && fieldDeposit.length > 0 && assetsWithCetipVoice.includes(assetTypeValueDeposit)) {
      $('#ticket_dation_payment_is_cetip_voice_deposit').removeAttr('readonly').removeAttr('disabled').show().parent().show();
    } else if (fieldDeposit.length > 0) {
      $('#ticket_dation_payment_is_cetip_voice_deposit').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
    }

    // Para dação - retirada
    const fieldWithdrawal = $('#ticket_dation_payment_is_cetip_voice_withdrawal');
    const assetTypeValueWithdrawal = $('#ticket_dation_payment_asset_type_withdrawal').children('option:selected').val();

    if (settlementType == 'cetip' && fieldWithdrawal.length > 0 && assetsWithCetipVoice.includes(assetTypeValueWithdrawal)) {
      $('#ticket_dation_payment_is_cetip_voice_withdrawal').removeAttr('readonly').removeAttr('disabled').show().parent().show();
    } else if (fieldWithdrawal.length > 0) {
      $('#ticket_dation_payment_is_cetip_voice_withdrawal').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
    }
  }

  const refreshFields = function(node) {
    const settlementType = $('input[name="ticket_private_fixed_income[settlement_type]"]:checked').val() || 
                           $('input[name="ticket_dation_payment[settlement_type]"]:checked').val();
    const $node = $(node);
    const newValue = $node.children('option:selected').val();
    const nodeId = $node.attr('id');

    // Para título privado
    if (nodeId === 'ticket_private_fixed_income_asset_type') {
      if (assetsWithCetipVoice.includes(newValue) && settlementType == 'cetip') {
        $('#ticket_private_fixed_income_is_cetip_voice').removeAttr('readonly').removeAttr('disabled').show().parent().show();
      } else {
        $('#ticket_private_fixed_income_is_cetip_voice').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
      }
    }

    // Para dação - depósito
    if (nodeId === 'ticket_dation_payment_asset_type_deposit') {
      if (assetsWithCetipVoice.includes(newValue) && settlementType == 'cetip') {
        $('#ticket_dation_payment_is_cetip_voice_deposit').removeAttr('readonly').removeAttr('disabled').show().parent().show();
      } else {
        $('#ticket_dation_payment_is_cetip_voice_deposit').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
      }
    }

    // Para dação - retirada
    if (nodeId === 'ticket_dation_payment_asset_type_withdrawal') {
      if (assetsWithCetipVoice.includes(newValue) && settlementType == 'cetip') {
        $('#ticket_dation_payment_is_cetip_voice_withdrawal').removeAttr('readonly').removeAttr('disabled').show().parent().show();
      } else {
        $('#ticket_dation_payment_is_cetip_voice_withdrawal').attr({ readonly: 'readonly', disabled: true }).hide().parent().hide();
      }
    }
  }

  settlementRadio.change(function() {
    refreshRadio(this);
  });

  for (let i = 0; i < settlementRadio.filter(':checked').length; i++) {
    refreshRadio(settlementRadio.filter(':checked')[i]);
  }

  nodes.change(function() {
    refreshFields(this);
  });

  for (let i = 0;i < nodes.length; i++) {
    if ($(nodes[i]).children('option:selected').length > 0) {
      refreshFields(nodes[i]);
    }
  }
});
